// Libraries
import { Skeleton, Typography } from "@mui/material";

// Types
import { Nullable } from "@Common/interfaces/types";

type ISocialMediaReviewStoreTitleProps = Readonly<{
	isLoading: boolean;
	title: Nullable<string>;
	isDataPresent: boolean;
}>;
export default function SocialMediaReviewStoreTitle(props: Readonly<ISocialMediaReviewStoreTitleProps>) {
	const { title, isLoading, isDataPresent } = props;

	if (isLoading || !title) {
		return <Skeleton variant="rectangular" height={30} width={480} sx={{ borderRadius: "6px" }} />;
	}

	if (!isDataPresent) {
		return null;
	}
	return (
		<Typography className={"page-title"} sx={{ lineHeight: "1.2" }}>
			{title}
		</Typography>
	);
}
